<script>

    import { orderStore, storeStore, modalStore } from '../stores'

    import ShipmentComponent from './component.shipment.svelte'
    import Modal from '../$components/modal.svelte'

    $: show = $modalStore === 'order_shipment_modal'
    $: isDefault = $modalStore === 'order_shipment_default_modal'

    function onCancel() {
        modalStore.set(null)
    }

</script>

{#if $orderStore}
    <Modal title="Orden #{$orderStore.number} {$orderStore.storeType}" show={show || isDefault} on:close={onCancel}>
        <ShipmentComponent order={$orderStore} store={$storeStore} {isDefault} />
    </Modal>
{/if}